<i18n src="@/locales/models/quality_inspect.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/harvested_batch.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/packing_house/quality_control/process/list_inspects.yml"
  lang="yaml"
></i18n>

<template>
  <div class="mt-8 flex flex-col">
    <div class="table-first-container">
      <div class="table-second-container">
        <div class="table-third-container">
          <table class="table">
            <thead class="table-header">
              <tr>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.quality_inspect.week") }}
                </th>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.quality_inspect.started_at") }}
                </th>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.quality_inspect.finished_at") }}
                </th>
                <th
                  scope="col"
                  class="table-header-cell"
                  v-for="quality_template_gui in quality_template.quality_template_guis"
                  :key="quality_template_gui.quality_attribute.id"
                >
                  {{
                    quality_template_gui.quality_attribute.crop_attribute.name
                  }}
                </th>
                <th scope="col" class="table-header-cell"></th>
              </tr>
            </thead>
            <tbody class="table-body">
              <tr
                class="table-row"
                v-for="quality_inspect in quality_inspects"
                :key="quality_inspect.id"
              >
                <td class="table-cell-pos">
                  {{ quality_inspect.week }}
                </td>
                <td
                  class="table-cell-main cursor-pointer"
                  @click.prevent="goToShow(quality_inspect)"
                >
                  {{ parseDate(quality_inspect.started_at) }}
                </td>
                <td
                  class="table-cell-main cursor-pointer"
                  @click.prevent="goToShow(quality_inspect)"
                >
                  {{ parseDate(quality_inspect.finished_at) }}
                </td>
                <td
                  class="table-cell"
                  v-for="quality_template_gui in quality_template.quality_template_guis"
                  :key="quality_template_gui.quality_attribute.id"
                >
                  <index-value
                    :quality_general="
                      qualityGeneralByInspectGUI(
                        quality_inspect,
                        quality_template_gui
                      )
                    "
                    :quality_template="quality_template"
                  />
                </td>
                <td class="table-cell-action">
                  <a
                    class="link flex"
                    @click.prevent="goToShow(quality_inspect)"
                  >
                    <i class="fa-solid fa-pen"></i>
                    <span class="space-icon"></span
                    >{{ $t("labels.manage_link") }}
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QualityTemplateGUIMixin from "@/components/views/layout/quality_control/mixins/quality_template_gui.js";
import IndexValue from "@/components/views/layout/quality_control/IndexValue.vue";

export default {
  name: "InspectionDetails",
  mixins: [QualityTemplateGUIMixin],
  components: { IndexValue },
  data() {
    return {};
  },
  props: {
    quality_template: {
      required: true,
    },
    quality_inspects: {
      required: true,
    },
    goToShow: {
      type: Function,
      required: true,
    },
  },
  methods: {
    parseDate: function (date) {
      if (!date) return "";

      return this.dateFormatter(
        this.removeTimeZoneToDate(date),
        "DD MMM hh:mm A",
        "YYYY-MM-DDTHH:mm::ss"
      );
    },
  },
};
</script>
